import { formatTime } from '../../util/index'
import { http } from '@/api/http'

const news = {
  state: {
    newsData01: [],
    newsData02: [],
  },
  mutations:{
    CLICK_SEARCH:(state,news) => {
      state.newsData01 = news.newsData01
      state.newsData02 = news.newsData02
    },
  },
  actions: {
    getNewsList: ({ commit }, params) => {
      return new Promise((resolve, reject)=>{
        http.get(process.env.BASE_API +'/capricorn-website/website/v1/company/news?station=cn',params).then((response)=> {
            // console.log(response)
            if(response.success && response.result){
                const newsList = response.result;
                if (newsList || Array.isArray(newsList)) {
                  let newsList01 = newsList['1'].list;
                  let newsList02 = newsList['2'].list;
                  newsList01.forEach((trace)=>{
                    trace.newsTime = formatTime(trace.newsTime,2)
                  });
                  newsList02.forEach((trace)=>{
                    trace.newsTime = formatTime(trace.newsTime,2)
                  });
                  commit('CLICK_SEARCH',{ 'newsData01' : newsList01,'newsData02' : newsList02});
                  resolve(response)
              }
            } else {
              reject()
            }
          }).catch(error=> {
            reject()
        })
      })
    }
  }
}
export default news;



// WEBPACK FOOTER //
// ./src/store/modules/news.js